const ACCESS_TOKEN_KEY = "access-token";
const REFRESH_TOKEN_KEY = "refresh-token";

export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY }